<script lang="ts" setup>
  import type { Complaint, ComplaintItem, ComplaintAndRefundAddress } from '@storefront/resources';

  interface Props {
    complaint: Complaint;
    complaintReturnAddress: ComplaintAndRefundAddress;
    items: ComplaintItem[];
  }

  defineProps<Props>();
</script>
<template>
  <main id="main" class="complaint container">
    <ComplaintDetailsView v-bind="$props" showHeader />
  </main>

  <RouterView />
</template>

<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .complaint {
    padding: 2rem 0;
    min-height: calc(100dvh - 198px);
  }

</style>